<template>
  <div class="box box_v" style="height: 100%">
    <div class="mini-header-wrapper">
      <div class="left">
        <div class="iconfont icon-fanhui2" style="font-size:35px" @click="$router.go(-1)"></div>
      </div>
      <div class="mini-header">广告发布</div>
      <div class="addManager">
        <Button class="bkcc-btn" :loading="loading4"  @click="fabu(4)">保存预览</Button>
        <Button class="bkcc-btn" :loading="loading0"  @click="fabu(0)">保存草稿</Button>
        <Button class="bkcc-btn"  @click="isTemCheck">选择模板</Button>
        <Button class="bkcc-btn" :loading="loading1"  @click="fabu(1)">发布</Button>
      </div>
    </div>
    <div class="item-wrapper box box_f1">
      <Card style="width: 100%;margin-right: 20px;margin-bottom: 20px;" :padding="0" class="card">
        <div class="display-box">
          <div class="form">
            <!--选择企业-->
            <div class="box mar-btm">
              <div class="_title">企业</div>
              <AutoComplete
                v-model="qySelect"
                :data="qyNameList"
                @on-search="searchChange"
                style="width:800px"
                @on-focus="searchQyList"
                placeholder="请输入企业名称"
                @on-select="selectQy"
              ></AutoComplete>
            </div>
          
            <!--标题-->
            <div class="box mar-btm">
              <div class="_title">广告标题</div>
              <Input v-model="title" style="width: 800px" :maxlength="32" />
              <div class="title-num">{{title.length}}/32</div>
            </div>
            <div class="box mar-btm">
              <div class="_title">广告链接</div>
              <Input placeholder="https://www.baidu.com" v-model="url" style="width: 800px"/>
            </div>
            <!--标题-->
            <div class="box mar-btm">
              <div class="_title">广告类型</div>
              <Select v-model="adType" style="width:350px" @on-change="changeType">
                  <Option v-for="item in ggtypeList" :value="item.value" :key="item.value">{{ item.label }}</Option>
              </Select>

              <div class="_title">广告位置</div>
              <Select v-model="orderType" style="width:350px" filterable @on-change="changeOrder">
                  <Option v-for="item in ggwzList[adType-1]" :value="item.value" :key="item.value">{{ item.label }}</Option>
              </Select>
            </div>
            
            <!--封面图-->
            <div class="box mar-btm" v-if="orderType!==0">
              <div class="_title">封面图</div>
              <upload-img
              
                :imgArr="imgArr"
                :imgNumber="imgNumber"
                :fixedNumber="fixedNumber"
                :imgHeight="148"
                :imgWidth="238"
                @saveImg="saveImg"
                @delPic="delPic"
                :isActive="isActive"
                class="upload"
              >
                <div class="uploadbox">
                  <i class="iconfont icon-shangchuan1"></i>
                  <p class="fengmian">请上传封面</p>
                  <p class="tips">注意图片尺寸为：{{ size1 }}</p>
                </div>
              </upload-img>
            </div>
            <!--内容-->
            <div class="box mar-btm">
              <div class="_title">广告详情</div>
              <editor-box
                :content="content"
                @editorContent="activityContent"
                :height="editorHeight"
                style="width: 815px"
              ></editor-box>
            </div>
          </div>
          <div class="app_box">
            <div class="top_box">
              <Icon type="ios-arrow-back" size="22" color="#fff" style="position: absolute;"/>
              <div class="title">广告详情</div>
              <div class="top_right_box">
                <Icon type="ios-more" size="28" color="#fff"/>
                <Divider type="vertical" />
                <Icon type="md-radio-button-on" size="20" color="#fff"/>
              </div>
            </div>
            <div class="body_box">
              <div class="titles" v-if="title">{{ title }}</div>
              <div class="time" v-if="title">{{ currentDateTime }}</div>
              <div class="time" v-if="selectQyId">企业：{{ qySelect }}</div>
              <div style="width: 100%;" v-html="content"></div>
              <Button type="info" style="margin: 10px;width: calc(100% - 20px);" v-if="url" @click="goUrl">立即前往</Button>
            </div>
          </div>
        </div>
        
      </Card>
    </div>
    <Modal v-model="showTemplate" title="选择模板" @on-ok="templateSel" width="910" >
      <div class="tem-con">
        <Input
          v-model="searchValue"
          search
          enter-button="搜索"
          placeholder="搜索广告"
          @on-search="getSchTemplate"
        />
        <div class="box template" style="flex-wrap: wrap">
          <div
            style="width: 25%;padding-right: 20px"
            v-for="(item, index) in tempList"
            :key="index"
            @click="checkTem(index)"
          >
            <div class="tem-item">
              <div class="box">
                <img :src="item.src" alt/>
              </div>
              <div class="tem-item-title" >{{item.title}}</div>
              <div class="tem-duigou" v-if="item.isCheck">
                <i class="iconfont icon-duigou" style="font-size: 50px"></i>
              </div>
            </div>
          </div>
        </div>
        <div class="page">
          <Page
            :total="temTotal"
            :page-size="8"
            show-total
            @on-change="temChange"
            :current="pageNumTem"
          />
        </div>
      </div>
    </Modal>
    <Modal v-model="hasTem" title="选择模板" class="has_tem" @on-ok="sureTem" width="910">
      <div class="check_tem">
        <p style="margin-top: 139px">您当前已编辑内容</p>
        <p style="margin-bottom: 372px">如应用模板，您的内容将被覆盖</p>
      </div>
    </Modal>
    <Modal v-model="modal2" title="提示" width="910">
      <div>
        <p style="font-size: 16px; color: #999">
          <i class="iconfont icon-htmal5icon28"></i>
          为保证广告宣传效果，最多可公示五篇广告，如要发布，请选择一篇取消展示或将当前编辑的广告保存草稿
        </p>
        <div class="box template" style="flex-wrap: wrap">
          <div
            style="width: 25%;padding-right: 20px"
            v-for="(item, index) in showList"
            :key="index"
            @click="checkNot(index)"
          >
            <div class="tem-item">
              <div class="box">
                <img :src="item.src" alt/>
              </div>
              <div class="tem-item-title">{{item.title}}</div>
              <div class="tem-duigou" v-if="item.isCheck">
                <i class="iconfont icon-duigou" style="font-size: 50px"></i>
              </div>
            </div>

          </div>
        </div>
      </div>
      <div slot="footer" class="modal_btn">
        <Button type="primary" class="check_btn" @click="modal2 = false">取消</Button>
        <Button type="primary" class="check_btn" @click="fabu(0)">保存草稿</Button>
        <Button type="primary" class="post_btn" @click="cxFabu">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
  import editorBox from "../../components/editorBox";
  import uploadImg from "../../components/uploadImg";

  export default {
    name: 'advertEdit',
    components: {
      editorBox,
      uploadImg,
    },
    data() {
      return {
        id: '',//广告id
        loading0: false,
        loading4: false,
        size1:'2:1',
        currentDateTime:'1999-01-01 00:00:00',
        loading1: false,
        adType:0,
        orderType:0,
        qyNameList: [],//企业名称列表
        qyIdList: [],//企业id列表
        qySelect: '',//选择的企业
        title: '',//广告标题
        imgNumber: 1,
        imgArr: [],
        ggwzList:[[],[]],
        ggtypeList:[
          {
            value:1,
            label:'业务广告'
          },{
            value:2,
            label:'固定广告'
          }
        ],
        fixedNumber: [2, 1],
        isActive: false,
        content: '',//广告详情
        editorHeight: "400px",
        selectQyId: '',
        url: '',
        showTemplate: false,//选择模板框是否显示
        searchValue: '',//模板框搜索的内容
        tempList: [],//模板列表
        temTotal: 0,//模板总数
        pageNumTem: 1,//模板页码
        hasTem: false,//是否展示覆盖内容确认模板
        tempId: '',//选择的模板id
        modal2:false,
        showList:[],
        showId:'',
      }
    },
    watch: {
      qySelect() {
        if (!this.qySelect) this.searchQyList()
      }
    },
    methods: {
      goUrl(){
        window.open(this.url)
      },
      changeOrder(val){
        let fixedNumber = this.ggwzList[this.adType-1].filter(item => item.value == val)[0].type
        
        
        if(fixedNumber){
          this.size1 = fixedNumber.replace(',', ':');
          fixedNumber = `[${fixedNumber}]`
          if(fixedNumber){
            fixedNumber = JSON.parse(fixedNumber) 
            this.fixedNumber = fixedNumber
          }
        }
        
      },
      updateDateTime() {
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0'); // 月份从0开始，所以要加1，并且补零
        const day = String(now.getDate()).padStart(2, '0');
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        const seconds = String(now.getSeconds()).padStart(2, '0');

        this.currentDateTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      },
      changeType(value,orderType=0){
        this.orderType = 0
        let index = value - 1
        if(this.ggwzList[index].length == 0){
          this.getggwzList(index,orderType)
        }
      },
      getggwzList(index,orderType=0){
        this.$get(this.urlobj.GetCodeByTypeforPhone, {
          typeName:index===0 ? 'ywgg' : 'gdgg'
        })
        .then(res => {
          if (res.isSucceed) {
            let list = res.rows.map(item => {
              return {
                value: item.domain,
                label: item.name,
                type: item.type,
              }
            })
            console.log(list);
            this.$set(this.ggwzList, index, list)
            
            if(orderType){
              this.orderType = ''+orderType
              this.changeOrder(this.orderType)
            }
            
            
            console.log(this.ggwzList[index]);
            
          }else{
            this.$Message.error(res.message)
          }
        })
        .catch(e => {
          console.error(e);
        });
      },
      //获取展示公告列表
      getAdvertShowlist () {
        var url = this.urlobj.getAdvert
        return this.$post(url,{
          pageNum:1,
          pageSize:5,
          status:1,
        }).then(res => {
          this.showList = res.rows.map(item => {
            return {
              src: item.coverPicUrl,
              title: item.title,
              id: item.id,
              isCheck :false,
            };
          });
        })
      },
      checkNot(index) {
        var list = this.showList;
        list.forEach(item => {
          item.isCheck = false;
        });
        list[index].isCheck = true;
        this.showId = list[index].id;
        this.showList = list;
      },
      cxFabu() {
        if (!this.showId) {
          this.$Message.warning('请选择一篇广告替换')
          return
        }
        var url = this.urlobj.changeAdStatus
        this.$post(url,{
          id:this.showId,
          status: 2
        }).then(res => {
          if (res.isSucceed) {
            this.$Message.success("操作成功");
            this.fabu(1);
          }
        })
      },
      // 输入框输入时
      searchChange(value) {
        console.log(this.qySelect)
        this.searchQyList()
      },
      // 搜索企业
      searchQyList() {
        let url = this.urlobj.getAddCompany;
        if(this.qySelect)
        this.$get(url, {
          companyName:this.qySelect, //查询企业名称
        }).then(res => {
          this.qyNameList = []
          this.qyIdList = []
          res.rows.forEach(item => {
            this.qyNameList.push(item.companyName)
            this.qyIdList.push(item.companyId)
          })
        })
      },
      // 选择企业
      selectQy(value) {
        var index = this.qyNameList.indexOf(value)
        this.selectQyId = this.qyIdList[index]
      },
      fabu(status) {
        // if (!this.selectQyId) {
        //   this.$Message.warning('请选择企业')
        //   return
        // }
        
        if (this.orderType===0 || this.adType ===0) {
          this.$Message.warning(this.adType === 0 ?'请选择广告类型':'请选择广告位置')
          return
        }
        var url = this.urlobj.addAd
        this[`loading${status}`] = true
        this.$post(url, {
          id: this.id,
          companyId: this.selectQyId,
          title: this.title,
          context: this.content,
          url: this.url,
          adType: this.adType,
          orderType: this.orderType,
          coverPicUrl: this.imgArr.length ? this.imgArr[0].path : '',
          status,//发送状态 0--草稿，1--公示，2--取消公示（历史）,4预览
        }).then(res => {
          this[`loading${status}`] = false
          if (res.isSucceed) {
            this.$Message.success('提交成功')
            this.$router.go(-1)
          }else{
            this.$Message.error(res.message)
          }
       
        }).catch(e => {
          this[`loading${status}`] = false
          if (e.data.code == 900130) {
            this.modal2 = true;
          }
        })
      },
      activityContent(data) {
        this.content = data;
      },
      saveImg(data) {
        this.imgArr.splice(0, 1, data);
        this.isActive = true;
      },
      delPic() {
        this.imgArr = [];
      },
      getDetail(id) {
        var url = this.urlobj.getAdDetail(id)
        this.$get(url).then(res => {
          var item = res.rows[0]
          this.selectQyId = item.companyId
          this.title = item.title
          this.url = item.url
          this.content = item.context
          this.adType = item.adType
          this.imgArr = item.coverPicUrl?[{path: item.coverPicUrl}]:[]
          this.qySelect = item.companyName
          this.changeType(item.adType,item.orderType)
        })

      },
      // 模板相关=======================
      isTemCheck() {
        this.showTemplate = true
      },
      templateSel() {
        if ((this.title != "" || this.imgArr.length || this.content != "") && this.tempId != "") {
          this.hasTem = true;
          return;
        }
        this.getDetail(this.tempId);
      },
      //搜索模板
      getSchTemplate() {
        this.pageNumTem = 1
        this.getTemplate()
      },
      temChange(val) {
        this.pageNumTem = val;
        this.getTemplate();
      },
      getTemplate() {
        var url = this.urlobj.getAllAdvert
        var data = {
          pageNum: this.pageNumTem,
          pageSize: 8,
          excludeId: this.id,
          title: this.searchValue
        };
        this.$get(url, data).then(res => {
          this.temTotal = res.total;
          var list = res.rows.map(item => {
            return {
              id: item.id,
              title: item.title,
              src: item.coverPicUrl == "" ? require("../../assets/images/apps/ex1.png") : item.coverPicUrl,
              isCheck: false
            };
          });
          this.tempList = list;
        });
      },
      sureTem() {
        this.getDetail(this.tempId);
      },
      checkTem(index) {
        var list = this.tempList;
        list.forEach(item => {
          item.isCheck = false;
        });
        list[index].isCheck = true;
        this.tempId = list[index].id;
        this.tempList = list;
      },
    },
    created() {
      this.updateDateTime();
      this.searchChange = this._.debounce(this.searchChange, 500);
    },
    mounted() {
      this.getAdvertShowlist()
      if (this.$route.query.id) {
        this.id = this.$route.query.id
        this.getDetail(this.id)
      }
      this.getTemplate()
    }
  }
</script>

<style scoped lang="less">
  /deep/ .ivu-select-dropdown-list {
    max-height: 300px;
    overflow-y: scroll;
  }

  /deep/ .ivu-select-dropdown-list::-webkit-scrollbar {
    width: 2px;
  }

  p {
    margin: 0;
    padding: 0;
  }
  .app_box{
    width: 360px;
    flex-shrink: 0;
    height: 640px;
    background: rgb(255, 255, 255);
    border-radius: 20px;
    position: fixed;
    box-shadow: 1px 1px 7px #cfcfcf;
    top: 180px;
    right: 50px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    .top_box{
      height:46px;
      background: #0097FF;
      display: flex;
      align-items: center;
      box-sizing: border-box;
      padding: 0 10px;
      .title{
        width: 100%;
        text-align: center;
        font-size: 16px;
        color: #fff;
      }
      .top_right_box{
        position: absolute;
        right: 10px;
        background: #1111112e;
        display: flex;
        align-items: center;
        border-radius: 40px;
        color: #ccc !important;
        border: 1px solid #ccc;
        padding: 0 10px;
      }
    }
    .body_box{
      flex: 1;
      flex-shrink: 0;
      overflow-y: auto;
      overflow-x: hidden;
      &::-webkit-scrollbar {
        width: 1px; /* 滚动条宽度 */
        background: #ccc;
      }
      .titles{
        width: calc(100% - 20px);
        margin: 10px;
        font-weight: 600;
        font-size: 18px;
      }
      .time{
        margin: 15px 10px;
        color: #999999;
      }
    }
  }

  .left {
    position: absolute;
    left: 20px;
    font-size: 22px;
  }

  .mini-header-wrapper {
    display: flex;
    /*height: 30px;*/
    line-height: 30px;
    padding: 30px 0;
    justify-content: center;
    position: relative;
  }

  .mini-header {
    font-size: 25px;
    text-align: center;
  }

  .addManager {
    /*background: #fd7c42;*/
    position: absolute;
    right: 20px;
    display: flex;
    align-items: center;
  }

  .item-wrapper {
    padding-left: 20px;
  }

  .uploadbox {
    width: 238px;
    height: 148px;
    border: 1px dashed #ddd;
    text-align: center;
    .icon-shangchuan1 {
      display: block;
      font-size: 37px;
      color: #e3e3e3;
      margin-top: 32px;
    }
    .fengmian {
      font-size: 14px;
      color: #666;
      margin-top: 10px;
    }
    .tips {
      font-size: 14px;
      color: #999;
    }
  }

  .form {
    padding: 20px;
    font-size: 18px;
    .mar-btm {
      margin-bottom: 20px;
    }
    ._title {
      width: 80px;
      text-align: right;
      margin-right: 20px;
    }
  }
  .display-box{
    display: flex;
  }
  /*.tem-con{*/
    /*width: 608px;*/
  /*}*/
  .tem-item {
    padding: 20px;
    border: 1px solid #dedede;
    border-radius: 5px;
    width: 100%;
    height: 188px;
    margin-top: 20px;
    position: relative;
    box-sizing: border-box;
    line-height: 1;
    img {
      height: 94px;
      width: 164px;
      border-radius: 5px;
    }
    .tem-item-title {
      font-size: 16px;
      color: #333;
      margin-top: 15px;
      line-height: normal;
      display: -webkit-box;
      -webkit-line-clamp:2;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-box-orient: vertical;
    }
  }

  .tem-duigou {
    width: 199px;
    height: 187px;
    border-radius: 5px;
    position: absolute;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.5);
    color: #fff;
    line-height: 188px;
    text-align: center;
  }
  .page {
    width: 100%;
    margin-top: 10px;
    display: flex;
    justify-content: center;
  }
  .check_tem {
    text-align: center;
    font-size: 16px;
    color: #999;
  }
  .title-num{
    color: #999;
    font-size: 16px;
    margin-left: 10px;
    align-self: center;
  }
</style>
<style scoped>
.body_box>>>img{
    max-width:360px !important;
  }
</style>